import React from "react";
import styled from "styled-components";
import DanceVideo1920 from "../video/dance_1920.mp4";
import DanceVideo1024 from "../video/dance_1024.mp4";
import DanceVideo768 from "../video/dance_768.mp4";
import DancePoster1920 from "../images/dance-posters/dance_1920.jpg";
import DancePoster1024 from "../images/dance-posters/dance_1024.jpg";
import DancePoster768 from "../images/dance-posters/dance_768.jpg";
import { siteColors } from "../constants/colors";
import breakpoints from "../constants/breakpoints";
import { useViewport } from "../utils/viewport-hook";

const DanceContainer = styled.div`
  width: 100%;
  background: ${siteColors.darkest};
  position: relative;
line-height: 0;
`;

const GradientDiv = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: linear-gradient( to bottom, rgba(9, 3, 20, 0) 0%, rgba(9, 3, 20, 0.0) 42%, rgba(9, 3, 20, 0.3) 55%, rgba(9, 3, 20, 0.45) 60%, rgba(9, 3, 20, 0.45) 80%, rgba(9, 3, 20, 0.25) 100% );
  z-index: 5;
`;

const TextContainer = styled.div`
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${siteColors.light};
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
line-height: 1.43;
  z-index: 10;
width: 100%;
`;

const InnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 6em;
  padding-bottom: 6em;
  width: 100%;
`;



const HeaderText = styled.div`
   white-space: nowrap;
   font-size: 4.0em;

  /* The text is too large to fit on a single line on smaller screens, so this
     bit of rigamarole breaks it conditionally based on screen width */
  .break-point::before {
    content: '';
  }

  @media (max-width: ${ breakpoints.desktopMediumHD }px) {
    font-size: 3.2em;
  }

  @media (max-width: ${ breakpoints.desktopSmallHD }px) {
    font-size: 2.6em;
  }

  @media (max-width: ${ breakpoints.half1080 }px) {
    font-size: 2.0em;
  }

  @media (max-width: ${ breakpoints.iPad }px) {
    font-size: 1.8em;
    text-align: center;

    .break-point::before {
      content: '\\A'; /* Inserts a line break */
      white-space: pre; /* Preserves the line break */
    }
  }

  @media (max-width: ${ breakpoints.xLargePhone }px) {
    font-size: 1.4em;
    text-align: center;

    .break-point::before {
      content: '\\A'; /* Inserts a line break */
      white-space: pre; /* Preserves the line break */
    }
  }

  @media (max-width: ${ breakpoints.mediumPhone }px) {
    font-size: 1.4em;
    text-align: center;

    .break-point::before {
      content: '\\A'; /* Inserts a line break */
      white-space: pre; /* Preserves the line break */
    }
  }
`;

const CopyText = styled.div`
    font-size: 2.0em;
  @media (max-width: ${ breakpoints.desktopSmallHD }px) {
    font-size: 1.4em;
  }
  @media (max-wid4h: ${ breakpoints.iPad }px) {
    font-size: 1.4em;
  }
  @media (max-width: ${ breakpoints.xLargePhone }px) {
    font-size: 1.0em;
  }
  @media (max-width: ${ breakpoints.mediumPhone }px) {
    font-size: 1.0em;
  }
`;

const videoSrc = width => {
    if (width > 1024) {
        return DanceVideo1920;
    }

    if (width > 768) {
        return DanceVideo1024;
    }

    return DanceVideo768;
};

const videoPoster = width => {
    if (width > 1024) {
        return DancePoster1920;
    }

    if (width > 768) {
        return DancePoster1024;
    }

    return DancePoster768;
};


const DanceVideo = ({ width }) => (
        <video width="100%" autoPlay muted loop key={1920} poster={videoPoster(width)} >
        <source src={videoSrc(width)} type="video/mp4" />
        </video>
);

const Dance = () => {
    const width = useViewport().width;

    return (
            <DanceContainer>
            <GradientDiv />
            <DanceVideo width={width} />
            <TextContainer>
            <InnerContainer>
            <div>
            <HeaderText>
            Coming Soon: <span className="break-point">The Ephemeral Animation System</span>
        </HeaderText>
            </div>
            </InnerContainer>
            </TextContainer>
            </DanceContainer>
    );
 };

export default Dance;
